import BasicService from "./BasicService";

class FinanceService extends BasicService {
    constructor() {
        super();
    }

    deleteFinance(finance) {
        let url = `/finance/${finance.financeId}`;
        return this.axios.delete(url, finance).then(request => request.data);
    }
    updateFinance(finance) {
        let url = `/finance/${finance.financeId}`;
        return this.axios.put(url, finance).then(request => request.data);
    }
    addFinance(finance) {
        let url = `/finance`;
        return this.axios.post(url, finance).then(request => request.data);
    }
    getFinance(fromDate, toDate, riderId) {
        let url = "/finance";
        return this.axios
          .get(url, {
            params: {
              fromDate,
              toDate,
              riderId
            }
          })
          .then(response => response.data);
      }

      getDailyRiderFinance(fromDate, toDate, riderId,status,type) {
        let url = "/finance/dailyrider";
        return this.axios
          .get(url, {
            params: {
              fromDate,
              toDate,
              riderId,status,type
            }
          })
          .then(response => response.data);
      }

      getRestBalanceFinance(fromDate, toDate, osId) {
        let url = "/finance/dailyrider/restBalance";
        return this.axios
          .get(url, {
            params: {
              fromDate,
              toDate,
              osId
            }
          })
          .then(response => response.data);
      }
      getDailyRestaurantFinance(fromDate, toDate, restaurantId,riderId) {
        let url = "/finance/dailyrestaurant";
        return this.axios
          .get(url, {
            params: {
              fromDate,
              toDate,
              restaurantId,
              riderId
            }
          })
          .then(response => response.data);
      }

      getDailyRiderPaymentFinance(fromDate, toDate, riderId) {
        let url = "/finance/dailyriderpayment";
        return this.axios
          .get(url, {
            params: {
              fromDate,
              toDate,
              riderId
            }
          })
          .then(response => response.data);
      }

}

const financeService = new FinanceService();
export default financeService;